import { render, staticRenderFns } from "./ReceiveSuccessModal.vue?vue&type=template&id=3077d165&scoped=true&"
import script from "./ReceiveSuccessModal.vue?vue&type=script&lang=js&"
export * from "./ReceiveSuccessModal.vue?vue&type=script&lang=js&"
import style0 from "./ReceiveSuccessModal.vue?vue&type=style&index=0&id=3077d165&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3077d165",
  null
  
)

export default component.exports